import {
  CHANGE_PASSWORD,
  CHANGE_PASSWORD_SUCCESS,
  CHANGE_PASSWORD_ERROR,
  GET_PASSWORD_HISTORY,
  GET_PASSWORD_HISTORY_SUCCESS,
  GET_PASSWORD_HISTORY_ERROR,
} from "./actionTypes";

export const userChangePassword = user => {
  return {
    type: CHANGE_PASSWORD,
    payload: { user },
  };
};

export const userChangePasswordSuccess = message => {
  return {
    type: CHANGE_PASSWORD_SUCCESS,
    payload: message,
  };
};

export const userChangePasswordError = message => {
  return {
    type: CHANGE_PASSWORD_ERROR,
    payload: message,
  };
};

// NEW: password change history
export const getPasswordHistory = user_id => {
  return {
    type: GET_PASSWORD_HISTORY,
    payload: { user_id },
  };
};

export const getPasswordHistorySuccess = history => {
  return {
    type: GET_PASSWORD_HISTORY_SUCCESS,
    payload: history,
  };
};

export const getPasswordHistoryError = message => {
  return {
    type: GET_PASSWORD_HISTORY_ERROR,
    payload: message,
  };
};
